import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { CommunityInvite, FRIENDS_LIST_PATH, communityInitials, friendInviteIntro } from '@radevents/shared';

/**
 * Die Einladungsseite ohne Abrufe: wer einlädt, warum sich die Freundschaft lohnt, und der eine
 * Knopf, der zum Zustand passt (Gast, angemeldet, schon befreundet, eigener Link).
 */
export function FriendInviteView({ invite, busy, error, account, onAccept, onLogin, onSwitchAccount }: {
  invite: CommunityInvite | null;
  busy?: boolean;
  error?: string;
  /** Mit welchem Konto angenommen wird, damit niemand auf einem fremden Rechner falsch zusagt. */
  account?: string;
  onAccept: () => void;
  onLogin: () => void;
  onSwitchAccount?: () => void;
}) {
  if (!invite) {
    return <section className="friend-invite friend-invite--missing" role="alert">
      <p>{error || friendInviteIntro('').notFound}</p>
      <Link to="/">Zu den Events</Link>
    </section>;
  }
  const t = friendInviteIntro(invite.firstName);
  const guest = invite.state === null && !invite.own;
  const friends = invite.state === 'FRIEND';
  return <section className="friend-invite" aria-labelledby="friend-invite-title">
    <span className="friend-invite-avatar" aria-hidden>{communityInitials(invite.firstName)}</span>
    <span className="friend-invite-kicker">{t.kicker}</span>
    <h1 id="friend-invite-title">{invite.own ? 'Dein Einladungslink' : t.title}</h1>
    {invite.own ? <p className="friend-invite-lead">{t.own}</p> : <>
      <p className="friend-invite-lead">{t.lead}</p>
      <ul>{t.points.map(point => <li key={point}><Check size={16} aria-hidden />{point}</li>)}</ul>
    </>}
    {error && <p role="alert" className="friend-invite-error">{error}</p>}
    {friends || invite.own
      ? <>{friends && <p className="friend-invite-done"><Check size={18} aria-hidden />{t.friends}</p>}
        <Link className="friend-invite-button" to={FRIENDS_LIST_PATH}>{t.toFriends}<ArrowRight size={17} aria-hidden /></Link></>
      : <>
        <button type="button" className="friend-invite-button" disabled={busy} onClick={guest ? onLogin : onAccept}>{guest ? t.login : t.accept}<ArrowRight size={17} aria-hidden /></button>
        {guest && <p className="friend-invite-hint">{t.loginHint}</p>}
        {!guest && account && <p className="friend-invite-hint">{t.signedInAs(account)}{onSwitchAccount && <> · <button type="button" className="friend-invite-switch" onClick={onSwitchAccount}>{t.switchAccount}</button></>}</p>}
      </>}
  </section>;
}
